import { createElementBlock as a, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(m, e, s, f, i, p) {
  return o(), a("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#F7F6EF",
        d: "M40.837 16.309c-1.255 0-2.438.261-3.472.782C36.59 11.948 32.158 8 26.84 8c-5.799 0-10.526 4.694-10.673 10.507-3.472.446-6.167 3.428-6.167 7.116-.002 3.948 3.175 7.153 7.09 7.153h23.747c4.506 0 8.163-3.69 8.163-8.235s-3.657-8.232-8.163-8.232Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m26.84 6.75-.298.004c-5.934.147-10.816 4.694-11.537 10.537l-.02.174-.235.064c-3.498 1.018-6 4.268-6 8.094-.003 4.635 3.732 8.403 8.34 8.403h23.747c5.199 0 9.413-4.251 9.413-9.485 0-5.232-4.214-9.482-9.413-9.482l-.362.006a9.337 9.337 0 0 0-2.083.307l-.117.032-.074-.25c-1.517-4.903-6.08-8.404-11.361-8.404Zm0 2.5c4.648 0 8.598 3.444 9.289 8.027a1.25 1.25 0 0 0 1.798.93c.847-.426 1.837-.648 2.91-.648 3.813 0 6.913 3.126 6.913 6.982 0 3.858-3.1 6.985-6.913 6.985H17.089c-3.221 0-5.84-2.643-5.839-5.903 0-3.015 2.185-5.504 5.076-5.876a1.25 1.25 0 0 0 1.09-1.208c.131-5.153 4.32-9.289 9.424-9.289ZM13.286 37.798a1.25 1.25 0 0 1 2.291.993l-.05.117-2.15 4.336a1.25 1.25 0 0 1-2.291-.993l.05-.118 2.15-4.335Zm2.579 7.371a1.25 1.25 0 0 1 2.29.993l-.05.118-2.15 4.335a1.25 1.25 0 0 1-2.29-.993l.05-.117 2.15-4.336Zm7.236-6.432a1.25 1.25 0 0 1 2.29.993l-.05.118-2.15 4.335a1.25 1.25 0 0 1-2.29-.993l.05-.117 2.15-4.336Zm7.894 1.239a1.25 1.25 0 0 1 2.27 1.039l-.057.124-.484.921a1.25 1.25 0 0 1-2.27-1.039l.057-.124.484-.921Zm9.743 0a1.25 1.25 0 0 1 2.27 1.039l-.057.124-.484.921a1.25 1.25 0 0 1-2.27-1.039l.057-.124.484-.921Zm-6.09 6.143a1.25 1.25 0 0 1 2.27 1.038l-.056.124-.484.922a1.25 1.25 0 0 1-2.27-1.039l.056-.124.485-.921Zm-9.742 2.457a1.25 1.25 0 0 1 2.27 1.039l-.057.124-.484.921a1.25 1.25 0 0 1-2.27-1.039l.056-.124.485-.921Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ t(c, [["render", r]]);
export {
  _ as default
};
